import { Pipe, PipeTransform } from '@angular/core';
import { List } from 'immutable';
import { PaymentTransaction } from '../../../document-data/sub-models/payment-transaction.model';
import { get } from 'lodash';

@Pipe({
  name: 'isDeposit',
})
export class IsDepositPipe implements PipeTransform {
  transform(
    transaction: PaymentTransaction,
    transactions: List<PaymentTransaction>
  ): any {
    if (!transaction.isDeposit) {
      const transactionParentTransactionId = transaction.parentTransactionId;
      const parentTransaction: PaymentTransaction = transactions.find(
        (t: PaymentTransaction) =>
          t.transactionId === transactionParentTransactionId
      );

      return get(parentTransaction, PaymentTransaction.KEYS.IS_DEPOSIT, false);
    }

    return true;
  }
}
